import { Avatar, AvatarFallback } from '@/ui/components/avatar';
import { cn, getColorFromId } from '@/ui/utils';
import { CSSProperties } from 'react';

interface Props extends React.ComponentProps<typeof Avatar> {
  organization: {
    id: string;
    name?: string | undefined;
  };
  size?: number;
}

export function OrganizationAvatar({ className, organization, size = 24, ...props }: Props) {
  const bgColor = getColorFromId(organization.id);

  return (
    <Avatar
      style={{ '--avatar-size': `${size}px` } as CSSProperties}
      className={cn('size-(--avatar-size)!', className)}
      {...props}
    >
      <AvatarFallback
        style={{ fontSize: 'calc(var(--avatar-size) * 0.45)' }}
        className={cn('text-white', bgColor)}
      >
        {organization.name?.[0]}
        {organization.name?.[1]}
      </AvatarFallback>
    </Avatar>
  );
}
